<template>
  <div class="app-content-skeleton" :class="`app-content-skeleton--${layout}`" role="status" :aria-label="label" aria-busy="true">
    <app-card v-if="layout === 'block'" design="new" padding="compact" aria-hidden="true">
      <div class="app-content-skeleton__block">
        <span class="app-content-skeleton__line app-content-skeleton__title" />
        <span class="app-content-skeleton__line" />
        <span class="app-content-skeleton__line" />
      </div>
    </app-card>
    <app-card v-else design="new" variant="table" header-density="compact" aria-hidden="true">
      <template #header><span class="app-content-skeleton__line app-content-skeleton__title" /></template>
      <app-data-table design="new" density="dense" :columns="columns" :rows="[]" :min-width="minWidth" :skeleton-rows="6" loading />
    </app-card>
  </div>
</template>

<script>
import AppCard from './AppCard.vue'
import AppDataTable from './AppDataTable.vue'

export default {
  name: 'AppContentSkeleton',
  components: { AppCard, AppDataTable },
  props: {
    label: { type: String, required: true },
    layout: { type: String, default: 'table', validator: value => ['table', 'block'].includes(value) },
    columns: { type: Array, default: () => [] },
    minWidth: { type: String, default: '1200px' }
  }
}
</script>

<style lang="scss" scoped>
.app-content-skeleton {
  min-width: 0;

  &--block { flex: 0 0 auto; }
  &__block {
    display: grid;
    gap: $ui-space-16;
    .app-content-skeleton__line:nth-child(2) { width: 65%; max-width: 520px; }
    .app-content-skeleton__line:nth-child(3) { width: 45%; max-width: 360px; }
  }
  &__line {
    display: block;
    height: 14px;
    border-radius: $ui-control-radius;
    background: $ui-line;
    animation: app-content-skeleton-pulse 1.3s ease-in-out infinite;
  }
  &__title { width: 160px; max-width: 100%; }
}
@keyframes app-content-skeleton-pulse { 50% { opacity: .45; } }
@media (prefers-reduced-motion: reduce) {
  .app-content-skeleton__line { animation: none; }
}
</style>
